// How long a locked cover (a free user's saved Create, status "locked") is
// held before it expires. Enforced by /api/v2/conversion/unlock, shown as
// the countdown on the cover page and the paywall, so the urgency is real.
export const LOCKED_HOLD_MS = 48 * 60 * 60 * 1000;

export const lockedExpiresAt = (createdAt: string | Date | undefined) =>
  new Date(new Date(createdAt || 0).getTime() + LOCKED_HOLD_MS);

export const isLockedExpired = (createdAt: string | Date | undefined) =>
  Date.now() >= lockedExpiresAt(createdAt).getTime();

// "47:12:03" until the hold ends ("0:00:00" once it has).
export const formatHoldLeft = (expiresAt: Date) => {
  const ms = Math.max(0, expiresAt.getTime() - Date.now());
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};
